import Login from "./Login";
import LoginIllustration from "./LoginIllustration";

const LoginPage = () => {
  return (
    <div className="min-h-screen flex">
      {/* Left Section */}
      <div className="w-full lg:w-1/2 flex items-center justify-center px-6 sm:px-12">
        <Login />
      </div>

      {/* Right Section (Hidden on mobile) */}
      <div className="hidden lg:flex w-1/2 bg-[#E8F0FF] items-center justify-center">
        <LoginIllustration />
      </div>
    </div>
  );
};

export default LoginPage;
